module.exports = __webpack_public_path__ + "img/flag_es.e4a115e.svg";